module.exports = __webpack_public_path__ + "static/media/favicon.cc7a14de.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/skins/conecta-prime/favicon.ico
// module id = 2175
// module chunks = 12